<app-page-heading [heading]="'Add a Drug-to-Drug Interaction'" [tabName]="'drug-interactions'"></app-page-heading>

<div *ngIf="isEdit && editDrugInteraction.interactionId == null" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div class="stepper-container">
    <mat-horizontal-stepper #stepper [linear]="true">
        <mat-step optional [stepControl]="addCategoryFormGroup">
            <ng-template matStepLabel>Categories</ng-template>
            <form [formGroup]="addCategoryFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Category Name</mat-label>
                            <input matInput [formControl]="addCategoryNameFormControl" type="text" [matAutocomplete]="categoryNewAuto" (input)="getFilteredListOfDrugInteractionCategories(0)">
                            <mat-autocomplete #categoryNewAuto="matAutocomplete">
                                <mat-option class="custom-mat-option" *ngFor="let category of drugInteractionCategories" [value]="category.name" (onSelectionChange)="drugInteractionCategorySelected(category)">
                                {{category.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button *ngIf="addCategoryNameFormControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="resetCategoryForm()">
                            <mat-icon style="color: grey;">clear</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #categoryNameTooltip="matTooltip" [matTooltip]="getInfoTooltip('Category')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>ATC Code</mat-label>
                            <input matInput type="search" [formControl]="atcCodeFormControl" [matAutocomplete]="atcAuto" (input)="filterAtcCodes()">
                            <mat-autocomplete #atcAuto="matAutocomplete">
                                <mat-option *ngFor="let atc of filteredAtcCodes" [value]="atc.name">
                                    {{atc.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button mat-icon-button matSuffix  (click)="addAtcCode()">
                                <mat-icon style="color: grey;">add</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #atcCodesTooltip="matTooltip" [matTooltip]="getInfoTooltip('ATC')">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <div formArrayName="atcCodes">
                    <div class="form-array" *ngFor="let atcCode of atcCodes.controls; let k=index">
                        <mat-form-field>
                            <mat-label>ATC Code {{k + 1}}</mat-label>
                            <input matInput [formControl]="atcCodes.controls[k]"/>
                            <span matSuffix><a style="cursor: pointer;" (click)="removeAtcCode(k)"><mat-icon>delete</mat-icon></a></span>
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <div class="save-button-container">
                <button *ngIf="isCategoryEdit" mat-raised-button color="warn" (click)="deleteCategory()">Delete</button>
                <button mat-raised-button color="primary" (click)="saveCategory()">{{saveCategoryText}}</button>
            </div>
            <div class="button-container">
                <button mat-raised-button color="warn" (click)="addCategoryFormGroup.reset()">Clear</button>
                <button mat-raised-button matStepperNext color="primary">Next</button>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Interaction</ng-template>
            <form [formGroup]="setInteractionFormGroup">
                <mat-grid-list cols="2" rowHeight="75px">
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Object Class Name</mat-label>
                            <input matInput [formControl]="categoryNameAFormControl" type="text" [matAutocomplete]="categoryAAuto" (input)="getFilteredListOfDrugInteractionCategories(1)" required>
                            <mat-autocomplete #categoryAAuto="matAutocomplete">
                                <mat-option class="custom-mat-option" *ngFor="let category of drugInteractionCategories" [value]="category.name" (onSelectionChange)="drugInteractionCategoryASelected(category)">
                                {{category.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button *ngIf="categoryNameAFormControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="categoryNameAFormControl.reset()">
                            <mat-icon style="color: grey;">clear</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #categoryATooltip="matTooltip" [matTooltip]="getInfoTooltip('Category A Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-form-field>
                            <mat-label>Precipatant Class Name</mat-label>
                            <input matInput [formControl]="categoryNameBFormControl" type="text" [matAutocomplete]="categoryBAuto" (input)="getFilteredListOfDrugInteractionCategories(2)" required>
                            <mat-autocomplete #categoryBAuto="matAutocomplete">
                                <mat-option class="custom-mat-option" *ngFor="let category of drugInteractionCategories" [value]="category.name" (onSelectionChange)="drugInteractionCategoryBSelected(category)">
                                {{category.name}}
                                </mat-option>
                            </mat-autocomplete>
                            <button mat-button *ngIf="categoryNameBFormControl.value" matSuffix mat-icon-button aria-label="Clear" (click)="categoryNameBFormControl.reset()">
                            <mat-icon style="color: grey;">clear</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-icon class="info-icon" #categoryBTooltip="matTooltip" [matTooltip]="getInfoTooltip('Category B Name')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2">
                        <mat-form-field>
                            <mat-label>Severity</mat-label>
                            <mat-select name="severity" [formControl]="severityFormControl" required>
                                <mat-option *ngFor="let severity of severities" [value]="severity.name">
                                    {{severity.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #severityTooltip="matTooltip" [matTooltip]="getInfoTooltip('severity')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2">
                        <mat-form-field>
                            <mat-label>Onset</mat-label>
                            <mat-select name="onset" [formControl]="onsetFormControl" required>
                                <mat-option *ngFor="let onset of onsets" [value]="onset.name">
                                    {{onset.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #onsetTooltip="matTooltip" [matTooltip]="getInfoTooltip('onset')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2">
                        <mat-form-field>
                            <mat-label>Management</mat-label>
                            <mat-select name="management" [formControl]="managementFormControl" required>
                                <mat-option *ngFor="let management of managements" [value]="management.name">
                                    {{management.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #managementTooltip="matTooltip" [matTooltip]="getInfoTooltip('management')">help_outline</mat-icon>
                    </mat-grid-tile>
                    <mat-grid-tile [colspan]="2">
                        <mat-form-field>
                            <mat-label>Documentation</mat-label>
                            <mat-select name="documentation" [formControl]="documentationFormControl" required>
                                <mat-option *ngFor="let documentation of documentations" [value]="documentation.name">
                                    {{documentation.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-icon class="info-icon" #documentationTooltip="matTooltip" [matTooltip]="getInfoTooltip('documentation')">help_outline</mat-icon>
                    </mat-grid-tile>
                </mat-grid-list>
                <div class="button-container">
                    <button mat-raised-button matStepperPrevious color="primary">Back</button>
                    <button mat-raised-button color="warn" (click)="setInteractionFormGroup.reset()">Clear</button>
                    <button mat-raised-button matStepperNext color="primary">Next</button>
                </div>
            </form>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>Finish</ng-template>
            <mat-grid-list cols="2" rowHeight="75px">
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Category A</p>
                        <p class="content">{{categoryNameAFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Category B</p>
                        <p class="content">{{categoryNameBFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Severity</p>
                        <p class="content">{{severityFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Onset</p>
                        <p class="content">{{onsetFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Management</p>
                        <p class="content">{{managementFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">Documentation</p>
                        <p class="content">{{documentationFormControl.value}}</p>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">ATC Codes for Category A</p>
                        <a class="link" (click)="openGenericDialog('ATC Codes for Category A')">View All</a>
                    </div>
                </mat-grid-tile>
                <mat-grid-tile>
                    <div class="display-field">
                        <p class="label">ATC Codes for Category B</p>
                        <a class="link" (click)="openGenericDialog('ATC Codes for Category B')">View All</a>
                    </div>
                </mat-grid-tile>
            </mat-grid-list>
            <div class="button-container">
                <button mat-raised-button matStepperPrevious color="primary">Back</button>
                <button mat-raised-button matStepperPrevious color="warn" (click)="stepper.reset()">Clear</button>
                <button mat-raised-button color="primary" (click)="finish()">Finish</button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
